module.exports = __webpack_public_path__ + "static/img/sb1.0eec3474.png";